import { Owner } from 'api'
import React, { ReactElement } from 'react'
import { ShareholderActions } from './shareholderActions'
import { DisplayShareholders } from './shareholderConfirmationTree'

interface EntityShareholderNodeProps {
  shareholder: Owner
  editShareholder: (shareholder: Owner) => void
  addShareholderToOwner: (shareholder: Owner) => void
  isRoot: boolean
  displayAddButton: boolean
}

export const EntityShareholderNode = ({
  shareholder,
  editShareholder,
  addShareholderToOwner,
  isRoot,
  displayAddButton,
}: EntityShareholderNodeProps): ReactElement => {
  return (
    <div className={isRoot ? 'mb-2' : 'ml-4 mb-2'}>
      <strong>{shareholder.legalBusinessName}</strong> ({shareholder.share}%)
      <ShareholderActions
        editShareholder={editShareholder}
        addShareholderToOwner={displayAddButton ? addShareholderToOwner : undefined}
        shareholder={shareholder}
      />
      <div>
        {shareholder.countryOfIncorporation && (
          <span className="text-muted">Country: {shareholder.countryOfIncorporation}</span>
        )}
        {shareholder.registrationNumber && (
          <span className="text-muted"> | Reg. No: {shareholder.registrationNumber}</span>
        )}
      </div>
      {!shareholder.shareholdersAttributes?.length && (
        <div className="text-danger">
          {shareholder.legalBusinessName} {'requires at least one individual shareholder'}
        </div>
      )}
      <div className="mt-2">
        <DisplayShareholders
          shareholders={shareholder.shareholdersAttributes}
          editShareholder={editShareholder}
          addShareholderToOwner={addShareholderToOwner}
          addShareholderToClient={() => null}
          isRoot={false}
        />
      </div>
    </div>
  )
}
